import { css } from 'styled-components'

export const outlineNegativeStyles = css`
  box-shadow: inset 0 0 0 4px black;
  outline: white 2px solid;
  box-sizing: border-box;
  outline-offset: -2px;
`

export const outlineStyles = css`
  box-shadow: 0 0 0 4px white;
  outline: black 2px solid;
  box-sizing: border-box;
`

export const outline = css`
  &:focus-visible {
    ${outlineStyles}
  }
`

export const outlineNegative = css`
  &:focus-visible {
    ${outlineNegativeStyles}
  }
`
